import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { BmarkOrderDataEventSource } from "./enums/BmarkOrderDataEventSource.enum";
import { BmarkOrderData } from "./BmarkOrderData.model";
import { BmarkOrderDataEventOperation } from "./enums/BmarkOrderDataEventOperation.enum";
import { BmarkFixingData } from "./BmarkFixingData.model";
import { BmarkFixingType } from "./enums/BmarkFixingType.enum";

export class BmarkOrderDataEvent {
  public operations: Array<BmarkOrderDataEventOperation>;
  public payload: BmarkOrderDataEventPayload;

  constructor() {
    this.operations = new Array<BmarkOrderDataEventOperation>();
  }

  public addOperations(
    operations: Array<BmarkOrderDataEventOperation> | BmarkOrderDataEventOperation,
  ): void {
    if (Array.isArray(operations)) {
      for (let operation of operations) {
        if (operation in BmarkOrderDataEventOperation) {
          this.operations.push(operation);
        } else {
          // error - unsupported operation
        }
      }
    } else if (operations in BmarkOrderDataEventOperation) {
      this.operations.push(operations);
    } else {
      //error
    }
  }
}

export class BmarkOrderDataEventPayload {
  public orderId: string;
  public orderRef: string;
  public ref: string;
  // public fixingId: string;
  public source: BmarkOrderDataEventSource;
  // BmarkOrderData
  public bmarkOrderData: BmarkOrderData = null;
  // meta-data
  public evtType: CubiqTS.FxLifeCycleEventType = null;
  public messageId: string = null;
  public tgcId: string | Array<string> = null;
  public sgcId: string = null;
  public deskCode: string | Array<string> = null;
  public state: CubiqTS.OrderState = null;
  public user: string = null;
  public deleteReason: string = null;
  //
  public lockEvent: boolean = false; //true,
  public isCreditUpdate: boolean = false; //false,
  public isRollbackEvent: boolean = false; //false,
  public isBmark: boolean = true; //true
  // transfer
  public xferEventType: CubiqTS.XferType = null;
  public xferComment: string = null;
  public xferUserName: string = null;
  public xferTargetGroup: string = null;
  // intervention
  public invEvtType: any = null;
  public invOprType: CubiqTS.InterventionOperationType = null;
  public reasonId: CubiqTS.DIReason = null;
  public unlockUserId: string = null;

  // active to recent move
  public readonly isFillBasedActiveToRecentMove: boolean = false;

  // errors
  public errors: any = null;

  public activeFixingId: string;
  public recentFixingId: string;
  // OMS-33341 / OMS-30944 allow delete in prior fixing when existingFixingId is selected rather than activeFixingId
  public existingFixingId: string;

  constructor(
    orderId: string,
    ref: string,
    source: BmarkOrderDataEventSource,
    // NOTE: use for id generation but do not retain!
    // MUST: selectively use bmarkOrderData when needed (presence modifies update flow)
    orderData: CubiqTS.OrderData,
    existingFixingId: string = null,
  ) {
    this.orderId = orderId;
    this.ref = ref;
    this.source = source;
    this.activeFixingId = BmarkFixingData.generateFixingIdFromOrderData(
      orderData,
      BmarkFixingType.ACTIVE,
    );
    this.recentFixingId = BmarkFixingData.generateFixingIdFromOrderData(
      orderData,
      BmarkFixingType.RECENT,
    );

    if (orderData != null) {
      this.orderRef = orderData.orderRef;
    }

    if (existingFixingId !== this.activeFixingId) this.existingFixingId = existingFixingId;
  }
}
